import * as React from "react";
function SvgLoader(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M22.1 2.7c-4.2 0-7.6 3.4-7.6 7.6s3.4 7.6 7.6 7.6 7.6-3.4 7.6-7.6-3.4-7.6-7.6-7.6zm16.3 10c-5.3 0-9.6 4.3-9.6 9.6s4.3 9.6 9.6 9.6 9.6-4.3 9.6-9.6-4.3-9.6-9.6-9.6zM5.7 16.5c-3.2 0-5.7 2.6-5.7 5.7S2.6 28 5.7 28s5.7-2.6 5.7-5.7-2.5-5.8-5.7-5.8zm6.2 21.1c-2.1 0-3.8 1.7-3.8 3.8 0 2.1 1.7 3.8 3.8 3.8s3.8-1.7 3.8-3.8c0-2.1-1.7-3.8-3.8-3.8zm20.3 2c-1.1 0-1.9.9-1.9 1.9 0 1.1.9 1.9 1.9 1.9 1.1 0 1.9-.9 1.9-1.9 0-1.1-.9-1.9-1.9-1.9z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLoader);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
